(() => {
  const root = window.Shopify?.routes?.root || '/';

  const mobileHeader = window.matchMedia('(max-width: 850px)');
  let lastHeaderScrollY = window.scrollY;
  let headerDirection = 0;
  let headerTravel = 0;
  let headerFrame = 0;
  const headerWrapper = () => document.querySelector('.site-header')?.parentElement;
  const showHeader = () => headerWrapper()?.classList.remove('is-scroll-hidden');
  const updateHeader = () => {
    headerFrame = 0;
    const wrapper = headerWrapper();
    if (!wrapper) return;
    const y = Math.max(0, window.scrollY);
    const delta = y - lastHeaderScrollY;
    lastHeaderScrollY = y;
    if (!mobileHeader.matches || y < 140 || wrapper.querySelector('.mobile-nav[open], :focus-visible')) {
      wrapper.classList.remove('is-scroll-hidden');
      headerTravel = 0;
      return;
    }
    if (Math.abs(delta) < 2) return;
    const direction = Math.sign(delta);
    headerTravel = direction === headerDirection ? headerTravel + Math.abs(delta) : Math.abs(delta);
    headerDirection = direction;
    if (direction > 0 && headerTravel > 24) wrapper.classList.add('is-scroll-hidden');
    if (direction < 0 && headerTravel > 18) wrapper.classList.remove('is-scroll-hidden');
  };
  window.addEventListener('scroll', () => {
    if (!headerFrame) headerFrame = window.requestAnimationFrame(updateHeader);
  }, { passive: true });
  mobileHeader.addEventListener('change', () => {
    lastHeaderScrollY = window.scrollY;
    headerTravel = 0;
    showHeader();
  });
  window.addEventListener('pageshow', showHeader);
  document.addEventListener('focusin', (event) => {
    if (headerWrapper()?.contains(event.target)) showHeader();
  });
  document.addEventListener('toggle', (event) => {
    if (event.target.matches('.mobile-nav') && event.target.open) showHeader();
  }, true);

  // The installed app dispatches this event only after Shopify accepts its cart add.
  document.addEventListener('build-your-print:cart-added', () => {
    window.location.assign(root + 'cart');
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-cart-form]');
    if (!form || !event.submitter?.matches('[data-cart-update]') || !window.fetch) return;
    event.preventDefault();
    const button = event.submitter;
    const status = form.querySelector('[data-cart-update-status]');
    const updates = {};
    for (const input of form.querySelectorAll('[data-cart-line-key]')) {
      const quantity = Number(input.value);
      if (!Number.isInteger(quantity) || quantity < 0) {
        input.focus();
        if (status) status.textContent = 'Vul een geldig aantal in.';
        return;
      }
      updates[input.dataset.cartLineKey] = quantity;
    }
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    if (status) status.textContent = 'Winkelwagen bijwerken…';
    try {
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates, note: form.elements.note?.value || '' })
      });
      if (!response.ok) throw new Error('Cart update failed');
      window.location.reload();
    } catch {
      button.disabled = false;
      form.removeAttribute('aria-busy');
      if (status) status.textContent = 'Bijwerken is niet gelukt. Probeer het opnieuw.';
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const price = select.closest('.product-details')?.querySelector('[data-product-price]');
    if (price) price.textContent = select.selectedOptions[0]?.dataset.price || price.textContent;
  });

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('.product-gallery');
    const main = gallery?.querySelector('.product-gallery__main img');
    if (!main || !thumb.dataset.largeSrc) return;
    main.src = thumb.dataset.largeSrc;
    main.srcset = '';
    main.alt = thumb.dataset.alt || '';
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
      const active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
  });

  document.addEventListener('input', (event) => {
    const range = event.target.closest('[data-comparison-range]');
    if (range) {
      range.closest('[data-image-comparison]')?.style.setProperty('--comparison-position', range.value + '%');
      return;
    }
    const search = event.target.closest('[data-faq-search]');
    if (!search) return;
    const group = search.closest('[data-faq-group]');
    const query = search.value.trim().toLocaleLowerCase();
    let visible = 0;
    group?.querySelectorAll('[data-faq-item]').forEach((item) => {
      item.hidden = !item.textContent.toLocaleLowerCase().includes(query);
      if (!item.hidden) visible += 1;
    });
    const status = group?.querySelector('[data-faq-count]');
    if (status) status.textContent = visible + ' vragen gevonden';
  });

  const articlePage = document.querySelector('[data-article-page]');
  if (articlePage) {
    const progress = document.querySelector('[data-article-progress]');
    const updateProgress = () => {
      if (!progress) return;
      const scrollLength = Math.max(1, articlePage.offsetHeight - window.innerHeight);
      const position = Math.min(1, Math.max(0, (window.scrollY - articlePage.offsetTop) / scrollLength));
      progress.style.transform = `scaleX(${position})`;
    };
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
  }

  document.addEventListener('click', async (event) => {
    const share = event.target.closest('[data-article-share]');
    if (!share) return;
    try {
      if (navigator.share) await navigator.share({ title: document.title, url: location.href });
      else if (navigator.clipboard) {
        await navigator.clipboard.writeText(location.href);
        share.textContent = 'Link gekopieerd ✓';
      }
    } catch (error) {
      if (error?.name !== 'AbortError') share.textContent = 'Delen is hier niet beschikbaar';
    }
  });

  if ('IntersectionObserver' in window && document.body.hasAttribute('data-reveal-enabled') && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .07, rootMargin: '0px 0px 45px 0px' });
    const observe = (scope) => {
      const nodes = scope.matches?.('[data-reveal]') ? [scope] : Array.from(scope.querySelectorAll('[data-reveal]'));
      nodes.forEach((node) => observer.observe(node));
    };
    observe(document);
    document.body.classList.add('reveal-ready');
    document.addEventListener('shopify:section:load', (event) => observe(event.target));
    document.addEventListener('shopify:block:select', (event) => event.target.querySelectorAll('[data-reveal]').forEach((node) => node.classList.add('is-visible')));
  }

  const interactiveSections = new WeakMap();
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  function initTiltDemo(section) {
    const frames = Array.from(section.querySelectorAll('[data-tilt-frame]'));
    const stage = section.querySelector('[data-tilt-stage]');
    const range = section.querySelector('[data-tilt-range]');
    if (frames.length < 2 || !stage || !range) return () => {};
    const permissionButton = section.querySelector('[data-tilt-permission]');
    const status = section.querySelector('[data-tilt-status]');
    let orientationHandler;
    let manualUntil = 0;
    let sensorTimeout;
    const setPosition = (value) => {
      const position = clamp(value, 0, 100);
      const framePosition = position / 100 * (frames.length - 1);
      stage.style.setProperty('--tilt-angle', `${(position - 50) * .6}deg`);
      frames.forEach((frame, index) => {
        frame.style.opacity = String(clamp(1 - Math.abs(framePosition - index), 0, 1));
      });
      range.value = String(Math.round(position));
      range.setAttribute('aria-valuetext', `Kijkhoek ${Math.round(position)} procent`);
    };
    const onRange = () => {
      manualUntil = Date.now() + 4000;
      setPosition(Number(range.value));
    };
    const onPointer = (event) => {
      manualUntil = Date.now() + 4000;
      const bounds = stage.getBoundingClientRect();
      setPosition((event.clientX - bounds.left) / bounds.width * 100);
    };
    const onPointerDown = (event) => {
      stage.setPointerCapture(event.pointerId);
      onPointer(event);
    };
    const onPointerMove = (event) => {
      if (stage.hasPointerCapture(event.pointerId)) onPointer(event);
    };
    const onPointerUp = (event) => {
      if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
    };
    range.addEventListener('input', onRange);
    stage.addEventListener('pointerdown', onPointerDown);
    stage.addEventListener('pointermove', onPointerMove);
    stage.addEventListener('pointerup', onPointerUp);
    stage.addEventListener('pointercancel', onPointerUp);
    setPosition(Number(range.value));

    const canTilt = matchMedia('(pointer: coarse)').matches && typeof window.DeviceOrientationEvent !== 'undefined' && window.isSecureContext;
    if (canTilt && permissionButton) permissionButton.hidden = false;
    const enableTilt = async () => {
      try {
        if (typeof DeviceOrientationEvent.requestPermission === 'function') {
          const permission = await DeviceOrientationEvent.requestPermission();
          if (permission !== 'granted') throw new Error('permission-denied');
        }
        let received = false;
        orientationHandler = (event) => {
          const angle = screen.orientation?.angle ?? window.orientation ?? 0;
          const normalizedAngle = ((angle % 360) + 360) % 360;
          const horizontalTilt = normalizedAngle === 90 ? event.beta : normalizedAngle === 270 ? -event.beta : event.gamma;
          if (typeof horizontalTilt !== 'number' || !Number.isFinite(horizontalTilt)) return;
          if (!received) {
            received = true;
            clearTimeout(sensorTimeout);
            if (status) status.textContent = 'Kantel je telefoon naar links en rechts.';
          }
          if (Date.now() >= manualUntil) setPosition((horizontalTilt + 30) / 60 * 100);
        };
        window.addEventListener('deviceorientation', orientationHandler, { passive: true });
        if (permissionButton) permissionButton.hidden = true;
        if (status) status.textContent = 'Kantelmodus wordt gestart…';
        sensorTimeout = setTimeout(() => {
          if (!received && status) status.textContent = 'Kantelen is hier niet beschikbaar. Veeg over de print.';
        }, 1800);
      } catch {
        if (status) status.textContent = 'Kantelen is hier niet beschikbaar. Veeg over de print.';
      }
    };
    permissionButton?.addEventListener('click', enableTilt);
    return () => {
      clearTimeout(sensorTimeout);
      if (orientationHandler) window.removeEventListener('deviceorientation', orientationHandler);
      permissionButton?.removeEventListener('click', enableTilt);
      range.removeEventListener('input', onRange);
      stage.removeEventListener('pointerdown', onPointerDown);
      stage.removeEventListener('pointermove', onPointerMove);
      stage.removeEventListener('pointerup', onPointerUp);
      stage.removeEventListener('pointercancel', onPointerUp);
    };
  }

  function initVideoShowcase(section) {
    const slides = Array.from(section.querySelectorAll('[data-video-slide]'));
    if (!slides.length) return () => {};
    const prev = section.querySelector('[data-video-prev]');
    const next = section.querySelector('[data-video-next]');
    const counter = section.querySelector('[data-video-counter]');
    let index = 0;
    const show = (newIndex) => {
      index = (newIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-current', active);
        slide.classList.toggle('is-next', slides.length > 1 && slideIndex === (index + 1) % slides.length);
        slide.classList.toggle('is-prev', slides.length > 2 && slideIndex === (index - 1 + slides.length) % slides.length);
        slide.toggleAttribute('inert', !active);
        slide.setAttribute('aria-hidden', String(!active));
        if (!active) slide.querySelector('video')?.pause();
      });
      if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    };
    const onPrev = () => show(index - 1);
    const onNext = () => show(index + 1);
    const onBlockSelect = (event) => {
      const slide = event.target.closest('[data-video-slide]');
      if (slide && section.contains(slide)) show(slides.indexOf(slide));
    };
    prev?.addEventListener('click', onPrev);
    next?.addEventListener('click', onNext);
    document.addEventListener('shopify:block:select', onBlockSelect);
    show(0);
    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) slides.forEach((slide) => slide.querySelector('video')?.pause());
      }, { threshold: .15 });
      observer.observe(section);
    }
    return () => {
      observer?.disconnect();
      prev?.removeEventListener('click', onPrev);
      next?.removeEventListener('click', onNext);
      document.removeEventListener('shopify:block:select', onBlockSelect);
      slides.forEach((slide) => slide.querySelector('video')?.pause());
    };
  }

  function initInteractiveSections(scope) {
    const sections = scope.matches?.('[data-tilt-demo], [data-video-showcase]') ? [scope] : Array.from(scope.querySelectorAll('[data-tilt-demo], [data-video-showcase]'));
    sections.forEach((section) => {
      if (interactiveSections.has(section)) return;
      interactiveSections.set(section, section.matches('[data-tilt-demo]') ? initTiltDemo(section) : initVideoShowcase(section));
    });
  }
  initInteractiveSections(document);
  document.addEventListener('shopify:section:load', (event) => initInteractiveSections(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-tilt-demo], [data-video-showcase]').forEach((section) => {
      interactiveSections.get(section)?.();
      interactiveSections.delete(section);
    });
  });

  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (!entry.isIntersecting) entry.target.pause(); });
    }, { threshold: .1 });
    const observeUgcVideos = (scope) => {
      const videos = scope.matches?.('[data-ugc-videos] video') ? [scope] : Array.from(scope.querySelectorAll('[data-ugc-videos] video'));
      videos.forEach((video) => videoObserver.observe(video));
    };
    observeUgcVideos(document);
    document.addEventListener('shopify:section:load', (event) => observeUgcVideos(event.target));
    document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-ugc-videos] video').forEach((video) => videoObserver.unobserve(video)));
  }
})();
